// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3E8fB","notAuthorizedBadge":"styles_notAuthorizedBadge__33Gn8","backBtn":"styles_backBtn__BeXD3"};